import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { routes } from '@/utils/routes/routes';
import { toast } from 'react-toastify';

const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  referral_code: yup.string().optional(),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), undefined], 'Passwords must match')
    .required('Confirm Password is required'),
});

const RegisterComponent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const refCode = queryParams.get('ref');
    if (refCode) {
      setValue('referral_code', refCode);
    }
  }, [location.search, setValue]);

  const onSubmit = async (data: any) => {
    const queryParams = new URLSearchParams(location.search);
    const isReferralSignup = !!queryParams.get('ref');

    try {
      setLoading(true);
      const response = await postData(end_points.register.url, data);
      if (response.status == 200 || response.status == 201) {
        toast.success('Registered Successfully');
        if (isReferralSignup) {
          navigate(routes.login);
        } else {
          navigate(-1);
        }
      }
    } catch (error: any) {
      console.log(error);
      toast.error(
        error?.response?.data?.email?.[0] ||
        error?.response?.data?.message ||
        'Registration Failed'
      );
    } finally {
      setLoading(false);
    }
    // Handle registration logic (e.g., API call)
  };

  return (
    <section className="user-login-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className='card-box'>
              <div className="card-header">
                <h2>Sign Up</h2>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>

                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    {...register('name')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.name?.message}</p>
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    {...register('email')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.email?.message}</p>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    {...register('password')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.password?.message}</p>
                </div>
                <div className="form-group">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    {...register('password_confirmation')}
                    className="form-control"
                  />
                  <p className="text-danger">
                    {errors.password_confirmation?.message}
                  </p>
                </div>
                <div className="form-group">
                  <label>Referral Code</label>
                  <input
                    type="text"
                    {...register('referral_code')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.referral_code?.message}</p>
                </div>
                <div className="form-group text-center">
                  <button
                    type="submit"
                    id="login-submit"
                    className="button style1"
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Register'}
                  </button>
                </div>
                <div className="text-center">
                  Already have an account? <Link to={routes.login}>Log In</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterComponent;
